import { usePartnerConfig } from '~/context/PartnerConfigContext';
import { MarketplacePartner } from '~/types/marketplace';

export const usePartner = (): MarketplacePartner => {
  const config = usePartnerConfig();
  return config?.id ?? 'brighte';
};
